import config from '@/core/config/config';
import { useCurrentUser, useNetworkStatus, useReferralCredits } from '@/hooks';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { ChevronDownLg, ChevronUpLg } from '@prenuvo/halo-icon';
import { Icon, Popover } from '@prenuvo/halo-web';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import PrenuvoHeaderLogo from './Logos/PrenuvoHeaderLogo';
import UserPopoverMenu from './UserPopoverMenu/UserPopoverMenu';

const Header = () => {
  const [arrowState, setArrowState] = useState<'down' | 'up'>('down');

  // TODO: add loading state
  const { data: currentUser, error } = useCurrentUser();

  const { addToPaymentSlice, setCurrentUser, setErrorModal, isLoggedIn } = usePrenuvoStore(
    useShallow((state) => ({
      addToPaymentSlice: state.payment.methods.add,
      setCurrentUser: state.user.methods.setCurrentUser,
      setErrorModal: state.ui.methods.setErrorModal,
      isLoggedIn: state.user.isLoggedIn,
    })),
  );

  const { data: referralCredit, error: referralCreditError } = useReferralCredits(
    currentUser?.userId,
  );

  const { isOnline } = useNetworkStatus();

  useEffect(() => {
    if (referralCredit && !referralCreditError) {
      addToPaymentSlice({
        referralCredit,
      });
    }
    if (referralCreditError) {
      setErrorModal('Error', 'There was an error fetching referral credits');
    }
  }, [referralCredit, referralCreditError, addToPaymentSlice, setErrorModal]);

  useEffect(() => {
    if (!isOnline) {
      setErrorModal('You are offline', 'Please check your internet connection and try again');
    }

    if (!error && currentUser && !isLoggedIn) {
      setCurrentUser(currentUser);
    }
  }, [currentUser, error, isOnline, isLoggedIn, setErrorModal, setCurrentUser]);

  const profileDropdownHandler = () => {
    setArrowState(arrowState === 'down' ? 'up' : 'down');
  };

  {
    /* TODO: get a trimmed image for the logo and remove some of the magic numbers */
  }
  return (
    <div className="flex h-14 items-end justify-between px-6 shadow-md md:h-[70px]">
      <div className="pb-3 md:pb-4">
        <figure className="w-[105px] md:w-[120px]">
          <a href={config.BASE_URL} target="_blank" aria-label="Prenuvo Header Logo">
            <PrenuvoHeaderLogo />
          </a>
          <figcaption className="sr-only">Prenuvo logo</figcaption>
        </figure>
      </div>

      <div className="pb-[19px] md:pb-6">
        {currentUser?.firstname && currentUser?.lastname ? (
          <Popover
            trigger={
              <div className="flex cursor-pointer justify-center gap-1">
                <p className="font-bold">{`${currentUser.firstname} ${currentUser.lastname}`}</p>
                <Icon
                  name="chevron-down"
                  source={arrowState === 'down' ? ChevronDownLg : ChevronUpLg}
                />
              </div>
            }
            onOpenChange={profileDropdownHandler}
          >
            <UserPopoverMenu user={currentUser} />
          </Popover>
        ) : (
          <a
            href={`${config.BASE_URL}/login`}
            className="block cursor-pointer items-center font-bold"
          >
            Sign in
          </a>
        )}
      </div>
    </div>
  );
};

export default Header;
